import { FC } from "react";

import { Stack } from "@mui/material";

import { BaseFormV2Step1Layout, BaseFormV2Step1LayoutProps } from "./BaseFormV2Step1Layout";

import { useMediaQuery } from "@/hooks/useMediaQuery";

export type PeerToPeerFormV2DonateToPrimaryCampaignStep1LayoutProps = Omit<BaseFormV2Step1LayoutProps, "slots"> & {
  slots: {
    banner?: React.ReactNode;
    organizationLogo: React.ReactNode;
    summary: React.ReactNode;
    donationAmounts: React.ReactNode;
    generateReceipt: React.ReactNode;
    zeffyBusinessModel: React.ReactNode;
    checkoutFooter: React.ReactNode;
    donors?: React.ReactNode;
  };
};

export const PeerToPeerFormV2DonateToPrimaryCampaignStep1Layout: FC<
  PeerToPeerFormV2DonateToPrimaryCampaignStep1LayoutProps
> = ({ slots, isOneColumn, isEmbed, ...rest }) => {
  const { isSmallScreen } = useMediaQuery();

  return (
    <BaseFormV2Step1Layout
      {...rest}
      slots={{
        banner: slots.banner,
        info: (
          <Stack alignItems="flex-start" width="100%" gap={2}>
            {!isSmallScreen && slots.organizationLogo}
            {slots.summary}
            {!isSmallScreen && !isOneColumn && !isEmbed && slots.donors}
          </Stack>
        ),
        order: (
          <Stack width="100%" gap={2}>
            {slots.donationAmounts}
            {(isSmallScreen || isOneColumn || isEmbed) && slots.donors}
            <Stack width="100%" gap={1}>
              {slots.generateReceipt}
              {slots.zeffyBusinessModel}
            </Stack>
          </Stack>
        ),
        checkoutFooter: slots.checkoutFooter,
      }}
    />
  );
};
